@if (wholeScreen) {
  <div
    class="whole-screen"
  >
    <i class='fa-regular fa-loader fa-spin'></i>
  </div>

} @else {
  <i class='fa-regular fa-loader fa-spin'></i>
}
